import type { CSSProperties } from 'react';

import { extractSizeFromClassName } from '../common';
import Avatar, { AvatarProps } from './Avatar';

export type TeamUserAvatarProps = Omit<AvatarProps, 'srcs' | 'alt'> & {
  userTeam?: {
    userTeamName?: string | null;
    profilePicture?: string | null;
    userEmail?: string | null;
    name?: string | null;
  };
  connected?: boolean;
};

export default function TeamUserAvatar({ userTeam, connected, ref, ...props }: TeamUserAvatarProps) {
  const size = extractSizeFromClassName(props.className);
  const isResponsive = size === 'full';
  const numericSize = typeof size === 'number' ? size : 12;

  const style: CSSProperties = {};

  // Only apply outline/shadow for connected users
  // - Green circle if connected (true)
  // - No circle if not connected (false) or unknown (undefined)
  if (!isResponsive) {
    const outlineSize = Math.floor(numericSize / 6);
    const shadowSize = Math.floor(numericSize / 4);

    if (connected === true) {
      style.outline = `${outlineSize}px solid hsl(120deg 84.08% 33.97%)`;
      style.boxShadow = `0 0 0px ${shadowSize}px var(--drop-shadow-color)`;
    }
  }

  return (
    <Avatar
      ref={ref}
      alt={userTeam?.userTeamName || userTeam?.userEmail || userTeam?.name || '?'}
      srcs={[userTeam?.profilePicture]}
      coloredBackground
      style={style}
      {...props}
    />
  );
}
